import { useState, useEffect } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';

interface LiveCounterProps {
  baseCount?: number;
  label?: string;
}

export function LiveCounter({ 
  baseCount = 7423, 
  label = "tasks completed this week" 
}: LiveCounterProps) {
  const [count, setCount] = useState(baseCount);

  // Simulate real-time updates
  useEffect(() => {
    const interval = setInterval(() => {
      // Randomly add 1-3 to the count
      setCount(prev => prev + Math.floor(Math.random() * 3) + 1);
    }, 3000 + Math.random() * 2000);

    return () => clearInterval(interval);
  }, []);

  const spring = useSpring(count, {
    stiffness: 100,
    damping: 30,
  });

  const display = useTransform(spring, (latest) => 
    Math.floor(latest).toLocaleString('en-IN')
  );

  useEffect(() => {
    spring.set(count);
  }, [count, spring]);

  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      {/* Live indicator */}
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-success" />
      </span>
      
      <span>
        <motion.span className="font-bold text-foreground tabular-nums">
          {display}
        </motion.span>
        {' '}{label}
      </span>
    </div>
  );
}
